<!--
 - Author : 003.wanghongling
 - Date   : 2019/6/4.
 - File   : consumeTotal.仓库区:农残检测记录
 -->

<template>
  <div class="consume-total">
    <div class="see" @click="showNcList">
      <i class="iconfont icon-xiangqing"></i>
    </div>
    <ckTitle title="食品快检记录">
      <div class="k-res">
        <div class="k-res-item" v-for="(item, index) in tableData" :key="index">
          <div class="k-res-item-left">
            <p>{{item.detectionDate}}</p>
            <p><span>食品名称</span>{{item.sampleName}}</p>
            <p><span>检测值</span>{{item.detectionValue}}</p>
          </div>
          <div class="k-res-item-right">
            <i :class="['iconfont', item.result==='不合格'?'icon-buhege':'icon-hege']"></i>
          </div>
        </div>
      </div>
      <div class="no-the-data" style="height: 300px" v-if="tableData.length === 0">
        <div>
          <i class="iconfont icon-ruku dzi" style="font-size: 40px;margin-bottom: 5px"></i>
          <p>暂无食品快检记录</p>
        </div>
      </div>
    </ckTitle>
    <datePopover title="食品快检记录"
        width="650px"
        v-if="showNCTag"
        :aqiMsg="currentPos"
        class="ncRecord"
        @closeEvent="showNCTag=false">
      <div class="pre-view">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="食品名称">
            <el-input v-model.trim="formInline.sampleName"></el-input>
          </el-form-item>
          <el-form-item label="选择时间">
            <el-col :span="9">
              <el-date-picker type="date" placeholder="选择开始日期" v-model="formInline.beginDate"
                   value-format="yyyy-MM-dd"
                  :picker-options="pickerOptionsStart"
                  style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">至</el-col>
            <el-col :span="8">
              <el-date-picker type="date" placeholder="选择结束日期" v-model="formInline.endDate"
                   value-format="yyyy-MM-dd"
                  :picker-options="pickerOptionsEnd"
                  style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="searchYcHisList" style="margin-left: 10px">查询</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div class="k-res" style="padding-top: 0" v-if="tableData1.length > 0">
        <div class="k-res-item" style="margin-bottom: 8px;" v-for="(item, index) in tableData1" :key="index">
          <div class="k-res-item-left">
            <p>{{item.detectionDate}}</p>
            <p><span>食品名称</span>{{item.sampleName}}</p>
            <p><span>检测值</span>{{item.detectionValue}}</p>
          </div>
          <div class="k-res-item-right">
            <i :class="['iconfont', item.result==='不合格'?'icon-buhege':'icon-hege']"></i>
          </div>
        </div>
      </div>
      <el-pagination
          v-if="tableData1.length > 0"
          background
          small
          :page-size="parseInt(pageSize)"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="totalCount">
      </el-pagination>
      <div class="no-the-data" style="height: 300px" v-if="tableData1.length === 0">
        <div>
          <i class="iconfont icon-ruku dzi" style="font-size: 40px;margin-bottom: 5px"></i>
          <p>暂无食品快检记录</p>
        </div>
      </div>
    </datePopover>
  </div>
</template>

<script>

  export default {
    name: 'consumeTotal',
    data () {
      return {
        consume: '',
        deptId: this.$route.query.deptId,
        tableData: [],
        tableData1: [],
        showNCTag: false,
        pageSize: 7,
        currentPage: 1,
        totalCount: 0,
        currentPos: {},
        formInline: {
          sampleName: '',
          beginDate: '',
          endDate: ''
        },
        pickerOptionsStart: {
          disabledDate: time => {
            if (this.formInline.endDate) {
              return time.getTime() > new Date(this.formInline.endDate).getTime()
            } else {
              return time.getTime() > Date.now()
            }
          }
        },
        pickerOptionsEnd: {
          disabledDate: time => {
            if (this.formInline.beginDate) {
              return (time.getTime() < new Date(this.formInline.beginDate).getTime() - 86400000) || (time.getTime() > Date.now())
            } else {
              return time.getTime() > Date.now()
            }
          }
        }
      }
    },
    mounted () {
      this.getNCList()
      this.getNewNCs()
      document.addEventListener('click', e => {
        if (!this.$el.contains(e.target)) this.showNCTag = false
      }, {passive: true})
    },
    methods: {
      /**
       * 条件查询异常信息
       * @author wanghongling
       * @createTime 2019/07/24
       */
      async searchYcHisList () {
        this.currentPage = 1
        this.getMoreNCList()
      },
      /**
       * websocket获取最新3条农残列表
       * @author wanghongling
       * @createDate 2019-07-25
       */
      getNewNCs () {
        window.getNewNC = () => {
          this.getNCList()
          this.getMoreNCList()
        }
      },
      /**
       * 获取农残信息前10条
       * @author wanghongling
       * @createDate 2019-07-25
       */
      async getNCList () {
        this.tableData = await this.getResultList(this.deptId, 1, 6)
      },
      /**
       * 获取更多农残信息
       * @author wanghongling
       * @createDate 2019-07-25
       */
      async getMoreNCList () {
        this.tableData1 = await this.getResultList(this.deptId, this.currentPage, this.pageSize, this.formInline.beginDate, this.formInline.endDate, this.formInline.sampleName)
      },
      /**
       * 点击显示更多列表
       * @author wanghongling
       * @createDate 2019-07-25
       */
      async showNcList () {
        this.showNCTag = !this.showNCTag
        this.formInline = {}
        this.getMoreNCList()
      },
      /**
       * 页码改变
       * @author wanghongling
       * @createDate 2019-07-23
       * @param {Object} e
       */
      async handleCurrentChange (e) {
        this.currentPage = e
        this.tableData1 = await this.getResultList(this.deptId, this.currentPage, this.pageSize, this.formInline.beginDate, this.formInline.endDate, this.formInline.sampleName)
      },
      /**
       * @Description:食品快检记录获取
       * @author wanghongling
       * @createDate 2020/5/8
       */
      getResultList (departmentId, page, pageSize, beginDate, endDate, sampleName) {
        let params = {
          departmentId: departmentId,
          page: page,
          pageSize: pageSize,
          beginDate: beginDate,
          endDate: endDate,
          sampleName: sampleName
        }
        return this.$request.detectionRecordListGet(params).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.log('食品快检记录获取', res)
            this.totalCount = res.totalCount
            return res.resultList
          }
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';

  .consume-total {
    position: relative;
    /*快检记录列表*/

    .k-res {
      padding: 15px 0;

      &-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #002938;
        margin-bottom: 15px;
        font-size: 14px;
        padding: 10px 15px;

        &-left {
          > p:first-child {
            color: #2d80a9;
          }

          > p {
            margin-bottom: 7px;
            color: #00ffff;
            font-size: 15px;

            > span {
              color: #a3a9ac;
              margin-right: 20px;
              font-size: 14px;
            }
          }

          > p:last-child {
            margin-bottom: 0;
            color: #00b7ee;
          }
        }

        &-right {
          .iconfont {
            font-size: 55px;
          }

          .icon-hege {
            color: #1eb107;
          }

          .icon-buhege {
            color: #d95900;
          }
        }
      }

      &-item:last-child {
        margin-bottom: 0;
      }
    }

    .see {
      position: absolute;
      right: 15px;
      top: 12px;
      cursor: pointer;

      i {
        font-size: 24px !important;
        color: #00fcff;
      }
    }

    .pre-view {
      color: #00b7ee;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    .hg {
      color: #2cff02;
    }

    .bhg {
      color: #ff7800;
    }

    .food-name {
      color: #00ffff;
    }

    .result {
      color: #00b7ee;
    }

    .time {
      color: #618496;
    }

    .ncRecord {
      position: absolute;
      right: 505px;
      top: 0;
      /*bottom: -30px;*/
    }

    /*表格样式重写*/

    .el-table thead {
      color: #a3a9ac;
    }

    .el-table tr {
      background-color: #01212d00;
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #031621;
    }

    .el-table th {
      padding: 4px 0;
    }

    .el-table td {
      padding: 2px 0;
    }

    .el-table td, .el-table th.is-leaf {
      border-bottom: none;
    }

    .el-table--border:after, .el-table--group:after, .el-table:before {
      content: "";
      position: absolute;
      background-color: rgba(0, 0, 0, 0);
      z-index: 1;
    }

    .el-table--fit {
      background: none !important;
    }

    .has-gutter tr th {
      background-color: #002f40;
    }

    /*分页样式*/

    .el-pagination {
      text-align: center;
      margin-bottom: 6px;
    }

    .el-pagination.is-background .el-pager li {
      background-color: inherit;
      color: #0aaade;
      margin: 0;
      font-size: 14px;
      font-weight: normal;
    }

    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
      background: inherit;
      color: #0aaade;
      margin: 0;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #004270 !important;
      color: #00ffff;
    }

    .el-input__inner, .el-textarea__inner {
      background-color: #022643 !important;
      border: 1px solid #0a5c9c !important;
    }

    .el-form-item__label {
      color: #fff !important;
    }

    .el-input__inner, .el-textarea__inner {
      color: #00ffff !important;
    }

    .line {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/consumeTotal.vue